import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClerk, useUser } from '@clerk/clerk-react';
import { useLanguage } from '../../hooks/useLanguage';
import logger from '../../utils/logger';

// Define public routes that should be accessible regardless of auth state
const PUBLIC_ROUTES = [
  '/',
  '/m3u-hls-player-features',
  '/m3u-hls-player-playlist-sharing',
  '/m3u-hls-player-sharing',
  '/free-m3u-hls-playlists',
  '/m3u-hls-player-faq',
  '/contact',
  '/privacy',
  '/terms',
  '/features',
  '/sharing',
  '/free-playlist',
  '/faq',
];

export const AuthStateManager = () => {
  const { user, isLoaded } = useUser();
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();
  const { session } = useClerk();

  useEffect(() => {
    if (!isLoaded) return;

    logger.log('Auth state changed:', {
      isAuthenticated: !!user,
      language: currentLanguage,
      sessionId: session?.id
    });

    // Check if current path is a public route
    const isPublicRoute = PUBLIC_ROUTES.some(route => 
      window.location.pathname === route
    );

    // Only redirect if user is authenticated and trying to access a non-public route
    if (user && !isPublicRoute) {
      logger.log('Authenticated user accessing protected route, redirecting');
      setTimeout(() => {
        navigate('/', { replace: true });
      }, 100);
    }
  }, [user, isLoaded, navigate, currentLanguage, session]);

  return null;
}; 